var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDropdownArrow = function SvgDropdownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5 3",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39.11a.345.345 0 0 1 .505 0c.14.146.14.384 0 .53L2.753 2.89a.345.345 0 0 1-.494.012L.116.839a.389.389 0 0 1-.022-.53.345.345 0 0 1 .505-.023l1.89 1.82L4.39.11Z",
    fillRule: "evenodd"
  })));
};

export default SvgDropdownArrow;